import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pointer plr-10 co-F52F3E" }

import { getCurrentInstance } from 'vue';
	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'RefuseBtn',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	
	const Operate = () => {
		emits("change");
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { onClick: Operate }, "拒绝")
  ]))
}
}

})